module.exports = __webpack_public_path__ + "container.svg?16a79cd21d17d27a1f70b8b087eabbf9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/container.svg
// module id = 92
// module chunks = 0